module.exports = __webpack_public_path__ + "img/me01.e0237d7f.png";